define('presentation/settings/forwardingNumbers/presentationObjects/forwardingNumbersVoicemailGreetingPresentationObject',[], function () {
    return function () {
        var self = this;

        self.greetingId = null;
        self.greetingName = null;
    };
});

